'use client'

import { useState } from 'react'
import Drawer from '@/components/ui/Drawer'
import { LuFilter } from 'react-icons/lu'
import DrawerFilterContent from './DrawerFilterContent'
import { useParams, useSearchParams } from 'next/navigation'
import { FaPhoneAlt } from 'react-icons/fa'

const DrawerFilter = () => {
    const [isOpen, setIsOpen] = useState(false)
    const params = useParams()
    const searchParams = useSearchParams()

    const slugArr = (params?.category as string[]) || []

    const openDrawer = () => {
        setIsOpen(true)
    }

    const onDrawerClose = () => {
        setIsOpen(false)
    }

    const Footer = (
        <div className="w-full text-base leading-6 font-normal tracking-[0.2px] text-[#414141]">
            <div className="flex gap-4 hover:underline cursor-pointer group">
                <FaPhoneAlt
                    size={20}
                    className="group-hover:text-blue-500 transition-colors"
                />
                <a
                    href="tel:+79166665339"
                    className="text-inherit hover:text-blue-500 hover:underline transition-colors"
                    aria-label="Позвонить +7 916 666 53 39"
                >
                    +7 916 666 53 39
                </a>
            </div>
        </div>
    )

    return (
        <div>
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => openDrawer()}
            >
                <div className="flex flex-col items-center justify-center">
                    <div className="w-[34px] h-[34px] flex justify-center items-center">
                        <LuFilter size={24} />
                    </div>

                    <span className="text-[10px] leading-[14px] tracking-[0.02px]">
                        Фильтры
                    </span>
                </div>
            </div>

            <Drawer
                title="Фильтры"
                placement="right"
                isOpen={isOpen}
                footer={Footer}
                onClose={onDrawerClose}
                onRequestClose={onDrawerClose}
                className="w-[300px]"
            >
                <DrawerFilterContent
                    slugArr={slugArr}
                    searchParams={Object.fromEntries(searchParams.entries())}
                />
            </Drawer>
        </div>
    )
}

export default DrawerFilter
